import { Link } from 'react-router-dom';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/data';

export default function LatestArticles() {
  const latestArticles = articles.slice(0, 3);

  return (
    <section className="py-10 md:py-14">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-center justify-between mb-6">
            <div>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading">
                最新资讯
              </h2>
              <p className="text-sm text-foreground-500 mt-1">影视圈最新动态与深度推荐</p>
            </div>
            <Link
              to="/category/dianshiju"
              className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 cursor-pointer whitespace-nowrap"
            >
              更多资讯 <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {latestArticles.map((article) => (
              <ArticleCard key={article.id} {...article} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}